import React from "react";
import { genderMap, maritalStatusMap } from "../../../helpers/mapping";
import { formatFullAddress, formatFullEmail, formatDocumentType, formatDocumentNumber, formatTelephoneNumbers, formatFullBirthDate } from "../../../helpers/format";
import dayjs from "dayjs";
import { Typography, useMediaQuery, useTheme } from "@mui/material";
import ShadowBox from "../container/ShadowBox";
import AttributeResponsive from "../../dataitem/AttributeResponsive";
import EditButton from "../../input/button/EditButton";
import SeasonRegistrationButton from "../../input/button/SeasonRegistrationButton";
import { useNavigate } from "react-router";
import SimpleBox from "../container/SimpleBox";
import { useSelector } from "react-redux";
import DialogSeasonConfirmation from "../../dialog/DialogSeasonConfirmation";

const PersonData = ({ personData, request = null, mt = 6, onSeasonConfirmation = null }) => {

    const theme = useTheme();

    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const navigate = useNavigate();
    const seasonToCheck = useSelector(state => state.seasons.seasonToCheck);
    const [open, setOpen] = React.useState(false);

    const genderOpt = genderMap().reduce((obj, item) => { obj[item.id] = item.label; return obj; }, {});
    const maritalStatusOpt = maritalStatusMap().reduce((obj, item) => { obj[item.id] = item.label; return obj; }, {});
    const telephoneNumbers = formatTelephoneNumbers(personData.phoneNrMobilePrimary, personData.phoneNrMobileSecondary, personData.phoneNrHome, personData.phoneNrWork);

    const formatStartDate = Boolean(personData.membershipStartDate) ? dayjs(personData.membershipStartDate).format("DD MMM YYYY") : null;
    const formatEndDate = Boolean(personData.membershipEndDate) ? dayjs(personData.membershipEndDate).format("DD MMM YYYY") : null;
    const rangeDateDescr = Boolean(personData.membershipStartDate) && Boolean(personData.membershipEndDate) ? (
        `De ${formatStartDate} a ${formatEndDate}`
    ) : (
        Boolean(personData.membershipStartDate) ? `Desde ${formatStartDate}` : (
            Boolean(personData.membershipEndDate) ? `Até ${formatEndDate}` : null
        )
    );
    const membershipSituation = Boolean(personData.membershipNumber) ? (
        personData.membershipNumber + (Boolean(rangeDateDescr) ? ` | ${rangeDateDescr}` : "")
    ) : "Não Sócio";

    const handleSeasonConfirmation = (action) => {
        if (action === "submit") {
            onSeasonConfirmation(personData.id);
            setOpen(false);
        }
        else {
            setOpen(false);
        }
    }

    return (
        <ShadowBox title="Dados Pessoais" titleVariant="h3" mt={mt}>
            <AttributeResponsive label="Nome Completo" value={personData.fullName} />
            <AttributeResponsive label="Nome Curto" value={personData.shortName} />
            <AttributeResponsive label="Email" value={formatFullEmail(personData.email, personData.paymentEmail)} />
            <AttributeResponsive label="NIF" value={personData.fiscalNumber ?? "-"} />
            <AttributeResponsive label="Morada" value={formatFullAddress(personData.address, personData.postCode, personData.town)} />
            <AttributeResponsive label={formatDocumentType(personData.idCardType)} value={formatDocumentNumber(personData.identificationNumber, personData.idCardValidity)} />
            <AttributeResponsive label="Telefone" value={Boolean(telephoneNumbers) ? telephoneNumbers : "-"} />
            <AttributeResponsive label="Género" value={genderOpt[personData.gender]} />

            <AttributeResponsive label="Data de Nascimento" value={formatFullBirthDate(personData.birthDate)} />
            <AttributeResponsive label="Naturalidade" value={personData.placeOfBirth} />
            <AttributeResponsive label="Nacionalidade" value={personData.nationality} />
            <AttributeResponsive label="Profissão" value={personData.job} />
            <AttributeResponsive label="Estado Civil" value={maritalStatusOpt[personData.maritalStatus]} />
            <AttributeResponsive label="Nome do Pai" value={personData.fatherName} />
            <AttributeResponsive label="Nome da Mãe" value={personData.motherName} />

            <AttributeResponsive label="Sócio" value={membershipSituation} />
            <AttributeResponsive label="Emails com Acesso" value={(personData.emails ?? []).join(" | ")} borderBottom={false} />

            <SimpleBox justifyContent="right" mt={2} gap={2}>
                {
                    Boolean(request) ? (
                        <Typography fontSize="0.9rem" color="textSecondary" fontStyle="italic">Não é possível alterar os dados porque já existe um pedido em curso</Typography>
                    ) : (
                        <EditButton onClick={() => navigate(`/edit-member/EDIT/${personData.id}`)} />
                    )
                }
                {
                    Boolean(onSeasonConfirmation) && Boolean(seasonToCheck) && !personData.confirmed ? (
                        <React.Fragment>
                            <SeasonRegistrationButton
                                label={`Inscrição ${seasonToCheck.acronym}`}
                                onClick={() => setOpen(true)} />
                            <DialogSeasonConfirmation
                                open={open}
                                season={seasonToCheck.acronym}
                                actionMethod={handleSeasonConfirmation} />
                        </React.Fragment>
                    ) : null
                }
            </SimpleBox>

        </ShadowBox>
    );
}

export default PersonData;
